import React from 'react'
import { PortableTextBodyElement } from '../../../utilities/blockContent'
import { isNullOrWhiteSpace } from '../../../utilities/string'
import { Button, ButtonTheme } from '../../Button'
import { ExternalIconSize } from '../../Link'
import { RichTextArea } from '../../PortableText/RichTextArea'
import { BasicBlockSerializer } from '../../PortableText/serializers/blocks/BasicBlockSerializer'

export interface NoAccessNoticeProps {
  body?: PortableTextBodyElement[]
  buttonLabel?: string
  buttonUrl?: string
  title?: string
}

export const NoAccessNotice = ({
  body,
  buttonLabel,
  buttonUrl,
  title,
}: NoAccessNoticeProps) => (
  <div>
    {!isNullOrWhiteSpace(title) && (
      <h1 className="mb-30 font-h2 text-h2 text-secondary-dark">{title}</h1>
    )}

    {body && (
      <div className="mb-45 font-body text-body text-secondary-darkest">
        <RichTextArea
          components={{
            block: BasicBlockSerializer,
          }}
          value={body}
        />
      </div>
    )}

    {!isNullOrWhiteSpace(buttonLabel) && !isNullOrWhiteSpace(buttonUrl) && (
      <Button
        externalIconSize={ExternalIconSize.None}
        isExternalUrl
        theme={ButtonTheme.Primary}
        url={buttonUrl}
      >
        {buttonLabel}
      </Button>
    )}
  </div>
)
